/**
 * Created by Thomas Mark
 * Date: 2021-04-07
 * 
 * Einzelne Produktgruppe ändern.
 *  
 */
import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';

import * as utils from "../../../basics/utils";
import * as appActions from "../../../store/actions/appActions";
import * as dirActions from "../../../store/actions/dirActions";
import * as portfolioActions from '../../../store/actions/portfolioActions';


const styles = (theme) => ({
    form: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),

        },
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing(1),
        minWidth: 400
    },
});

class GroupModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'GroupModal';

        this.debug = false;

        this.initGroup = {
            name: '',
        }

        this.state = {
            newGroup: this.initGroup,
            oldGroup: this.initGroup,
            validationError: false,
            validationMessage: "",
        }
        this.node = null;
    }

    // ==========================================================================
    //
    // HELPER - SECTION
    //
    // ==========================================================================

    validateWidget = (id, value) => {
        const { currentPortfolio } = this.props.portfolio;

        this.debug && console.log(`validateWidget(${id}, ${value})`);

        let newState = { validationError: false, validationMessage: '' };

        // Feld 'name' prüfen
        if (id === 'name') {
            if (/[^-&öüäÖÜÄß\w+( +\w+)*$]/.test(value)) {
                newState = { validationError: true, validationMessage: 'Wert ist ungültig!' };
            }
        }

        // Prüfen, ob Feld leer ist
        if (value === '') {
            newState = { validationError: true, validationMessage: 'Feld darf nicht leer sein!' };
        }

        // Prüfen, ob das Gruppen-Verzeichnis schon existiert
        if (currentPortfolio && currentPortfolio['children']) {
            const existsFilter = currentPortfolio.children.filter((f) => f.name.toLowerCase() === value.toLowerCase());
            if (existsFilter.length > 0) {
                newState = { validationError: true, validationMessage: 'Gruppe existiert bereits!' };
            }
        }

        this.debug && console.log(newState);

        this.setState(newState);
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidUpdate(prevProps) {
        const { modalDialog } = this.props.app;
        const { currentGroup } = this.props.portfolio;

        if (modalDialog.dialog === this.component && modalDialog.dialog !== prevProps.app.modalDialog.dialog) {

            if (modalDialog.type === 'create') {
                this.setState({ newGroup: this.initGroup, validationError: false, validationMessage: '' })
            } else {
                this.setState({ newGroup: currentGroup, oldGroup: currentGroup, validationError: false, validationMessage: '' })
            }
        }
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog, path } = this.props.app;
        const { newGroup, validationError, validationMessage } = this.state;
        const { classes } = this.props;
        const { currentGroup } = this.props.portfolio;

        const dialog = utils.getDialogByPath(path);

        const exitModal = () => {
            this.props.scanPortfolio(dialog.portfolio, null, null, dialog.portfolio + '/' + newGroup.name);
            this.props.closeModalDialog(); // appAction.js
        }

        const onError = (error) => {
            const newState = { validationError: true, validationMessage: error.response.data.message };

            this.debug && console.log(newState);

            this.setState(newState);
        }

        const onCreateGroup = () => {
            const onCreateSuccess = () => {
                exitModal();
            }

            this.props.createDir(path + '/' + newGroup.name, onCreateSuccess, onError);
        }

        const onUpdateGroup = () => {
            const onRenameSuccess = (data) => {
                currentGroup.name = newGroup.name;
                exitModal();
            }

            if (currentGroup.name !== newGroup.name) {
                this.props.renameDir(path, newGroup.name, onRenameSuccess, onError);
            } else {
                exitModal();
            }
        }

        const onDeleteGroup = () => {
            const onDeleteSuccess = () => {
                this.props.scanPortfolio(dialog.portfolio, null, null, dialog.portfolio);
                this.props.setModalDialog(null, null)
            }

            this.props.deleteDir(path, onDeleteSuccess, onError);
        }

        const onSave = () => {
            if (modalDialog.type === 'create') { onCreateGroup() }
            if (modalDialog.type === 'update') { onUpdateGroup() }
            if (modalDialog.type === 'delete') { onDeleteGroup() }
        }

        const onCancel = () => {
            this.props.setModalDialog(null, null)
        }

        const onChange = (e) => {
            this.validateWidget(e.target.id, e.target.value);

            this.setState({ newGroup: { ...newGroup, [e.target.id]: e.target.value } });
        }

        const onSubmit = (e) => {
            e.preventDefault();
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        let dialogTitle = '';
        if (modalDialog.type === 'create') dialogTitle = 'Produktgruppe erstellen';
        if (modalDialog.type === 'update') dialogTitle = 'Produktgruppe ändern';
        if (modalDialog.type === 'delete') dialogTitle = 'Produktgruppe löschen';

        const disabled = modalDialog.type === 'delete';

        return (
            <div>
                <Dialog open={true} onClose={onCancel} maxWidth={'md'} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
                    <DialogContent>
                        <form className={classes.form} noValidate onSubmit={onSubmit}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    autoFocus
                                    autoComplete="off"
                                    id="name"
                                    label="Titel"
                                    type="text"
                                    fullWidth={true}
                                    disabled={disabled}
                                    value={newGroup.name}
                                    onChange={onChange}
                                    InputLabelProps={{ shrink: true }}
                                    margin="normal"
                                />
                            </FormControl>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCancel} variant="outlined" color="default">Abbruch</Button>
                        <Button onClick={onSave} variant="contained" color="primary" disabled={validationError}>OK</Button>
                    </DialogActions>
                    <Typography className="w-full px-8" variant="h6" noWrap>
                        {validationMessage === '' ? <span>&nbsp;</span> : validationMessage}
                    </Typography>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        dir: state.dir,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, dirActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GroupModal));